import { call, all, put, takeLatest } from "redux-saga/effects";

import {
  LEAD_TYPE_LIST,
  LEAD_TYPE_DATA,
  LEAD_TYPE_CREATE,
  LEAD_TYPE_UPDATE,
  LEAD_TYPE_DELETE,
  LEAD_STATUS_LIST,
  LEAD_STATUS_DATA,
  LEAD_STATUS_CREATE,
  LEAD_STATUS_UPDATE,
  LEAD_STATUS_DELETE,
  LEAD_PRIORITY_LIST,
  LEAD_PRIORITY_DATA,
  LEAD_PRIORITY_CREATE,
  LEAD_PRIORITY_UPDATE,
  LEAD_PRIORITY_DELETE,
  LEAD_NOTE_LIST,
  LEAD_NOTE_SEARCH,
  LEAD_NOTE_DATA,
  LEAD_NOTE_CREATE,
  LEAD_LIST,
  LEAD_LIST_UNINVOICED,
  LEAD_OVERVIEW_FUNNEL,
  LEAD_DATA,
  LEAD_CREATE,
  LEAD_UPDATE,
  LEAD_DELETE,
  LEAD_SEARCH,
  LEAD_TASK_SEARCH,
  LEAD_TASK_CREATE,
  LEAD_TASK_TYPE_LIST,
  LEAD_TASK_TYPE_DATA,
  LEAD_TASK_TYPE_CREATE,
  LEAD_TASK_TYPE_UPDATE,
  LEAD_TASK_TYPE_DELETE,
  LEAD_RECENT_ACTIVITY_LIST,
} from "./actionType";

import {
  leadTypeListSuccess,
  leadTypeListFailure,
  leadTypeDataSuccess,
  leadTypeDataFailure,
  leadTypeCreateSuccess,
  leadTypeCreateFailure,
  leadTypeUpdateSuccess,
  leadTypeUpdateFailure,
  leadTypeDeleteSuccess,
  leadTypeDeleteFailure,
  leadStatusListSuccess,
  leadStatusListFailure,
  leadStatusDataSuccess,
  leadStatusDataFailure,
  leadStatusCreateSuccess,
  leadStatusCreateFailure,
  leadStatusUpdateSuccess,
  leadStatusUpdateFailure,
  leadStatusDeleteSuccess,
  leadStatusDeleteFailure,
  leadPriorityListSuccess,
  leadPriorityListFailure,
  leadPriorityDataSuccess,
  leadPriorityDataFailure,
  leadPriorityCreateSuccess,
  leadPriorityCreateFailure,
  leadPriorityUpdateSuccess,
  leadPriorityUpdateFailure,
  leadPriorityDeleteSuccess,
  leadPriorityDeleteFailure,
  leadNoteListSuccess,
  leadNoteListFailure,
  leadNoteSearchSuccess,
  leadNoteSearchFailure,
  leadNoteDataSuccess,
  leadNoteDataFailure,
  leadNoteCreateSuccess,
  leadNoteCreateFailure,
  leadListSuccess,
  leadListFailure,
  leadListUninvoicedSuccess,
  leadListUninvoicedFailure,
  leadOverviewFunnelSuccess,
  leadOverviewFunnelFailure,
  leadDataSuccess,
  leadDataFailure,
  leadCreateSuccess,
  leadCreateFailure,
  leadUpdateSuccess,
  leadUpdateFailure,
  leadDeleteSuccess,
  leadDeleteFailure,
  leadSearchSuccess,
  leadSearchFailure,
  leadTaskSearchSuccess,
  leadTaskSearchFailure,
  leadTaskCreateSuccess,
  leadTaskCreateFailure,
  leadTaskTypeListSuccess,
  leadTaskTypeListFailure,
  leadTaskTypeDataSuccess,
  leadTaskTypeDataFailure,
  leadTaskTypeCreateSuccess,
  leadTaskTypeCreateFailure,
  leadTaskTypeUpdateSuccess,
  leadTaskTypeUpdateFailure,
  leadTaskTypeDeleteSuccess,
  leadTaskTypeDeleteFailure,
  leadRecentActivityListSuccess,
  leadRecentActivityListFailure,
} from "./action";

import {
  callLeadTypeListApi,
  callLeadTypeDataApi,
  callLeadTypeCreateApi,
  callLeadTypeUpdateApi,
  callLeadTypeDeleteApi,
  callLeadStatusListApi,
  callLeadStatusDataApi,
  callLeadStatusCreateApi,
  callLeadStatusUpdateApi,
  callLeadStatusDeleteApi,
  callLeadPriorityListApi,
  callLeadPriorityDataApi,
  callLeadPriorityCreateApi,
  callLeadPriorityUpdateApi,
  callLeadPriorityDeleteApi,
  callLeadNoteListApi,
  callLeadNoteSearchApi,
  callLeadNoteDataApi,
  callLeadNoteCreateApi,
  callLeadListApi,
  callLeadListUninvoicedApi,
  callLeadOverviewFunnelApi,
  callLeadDataApi,
  callLeadCreateApi,
  callLeadUpdateApi,
  callLeadDeleteApi,
  callLeadSearchApi,
  callLeadTaskSearchApi,
  callLeadTaskCreateApi,
  callLeadTaskTypeListApi,
  callLeadTaskTypeDataApi,
  callLeadTaskTypeCreateApi,
  callLeadTaskTypeUpdateApi,
  callLeadTaskTypeDeleteApi,
  callLeadRecentActivityListApi,
} from "../../helpers/fakebackend_helper";

// LEAD_TYPE_LIST
function* leadTypeListSaga({ payload }) {
  try {
    const response = yield call(callLeadTypeListApi, payload);
    yield put(leadTypeListSuccess(response));
  } catch (error) {
    yield put(leadTypeListFailure(error));
  }
}
function* watchLeadTypeListSaga() {
  yield takeLatest(LEAD_TYPE_LIST, leadTypeListSaga);
}

// LEAD_TYPE_DATA
function* leadTypeDataSaga({ payload }) {
  try {
    const response = yield call(callLeadTypeDataApi, payload);
    yield put(leadTypeDataSuccess(response));
  } catch (error) {
    yield put(leadTypeDataFailure(error));
  }
}
function* watchLeadTypeDataSaga() {
  yield takeLatest(LEAD_TYPE_DATA, leadTypeDataSaga);
}

// LEAD_TYPE_CREATE
function* leadTypeCreateSaga({ payload }) {
  try {
    const response = yield call(callLeadTypeCreateApi, payload);
    yield put(leadTypeCreateSuccess(response));
  } catch (error) {
    yield put(leadTypeCreateFailure(error));
  }
}
function* watchLeadTypeCreateSaga() {
  yield takeLatest(LEAD_TYPE_CREATE, leadTypeCreateSaga);
}

// LEAD_TYPE_UPDATE
function* leadTypeUpdateSaga({ payload }) {
  try {
    const response = yield call(callLeadTypeUpdateApi, payload);
    yield put(leadTypeUpdateSuccess(response));
  } catch (error) {
    yield put(leadTypeUpdateFailure(error));
  }
}
function* watchLeadTypeUpdateSaga() {
  yield takeLatest(LEAD_TYPE_UPDATE, leadTypeUpdateSaga);
}

// LEAD_TYPE_DELETE
function* leadTypeDeleteSaga({ payload }) {
  try {
    const response = yield call(callLeadTypeDeleteApi, payload);
    yield put(leadTypeDeleteSuccess(response));
  } catch (error) {
    yield put(leadTypeDeleteFailure(error));
  }
}
function* watchLeadTypeDeleteSaga() {
  yield takeLatest(LEAD_TYPE_DELETE, leadTypeDeleteSaga);
}

// LEAD_STATUS_LIST
function* leadStatusListSaga({ payload }) {
  try {
    const response = yield call(callLeadStatusListApi, payload);
    yield put(leadStatusListSuccess(response));
  } catch (error) {
    yield put(leadStatusListFailure(error));
  }
}
function* watchLeadStatusListSaga() {
  yield takeLatest(LEAD_STATUS_LIST, leadStatusListSaga);
}

// LEAD_STATUS_DATA
function* leadStatusDataSaga({ payload }) {
  try {
    const response = yield call(callLeadStatusDataApi, payload);
    yield put(leadStatusDataSuccess(response));
  } catch (error) {
    yield put(leadStatusDataFailure(error));
  }
}
function* watchLeadStatusDataSaga() {
  yield takeLatest(LEAD_STATUS_DATA, leadStatusDataSaga);
}

// LEAD_STATUS_CREATE
function* leadStatusCreateSaga({ payload }) {
  try {
    const response = yield call(callLeadStatusCreateApi, payload);
    yield put(leadStatusCreateSuccess(response));
  } catch (error) {
    yield put(leadStatusCreateFailure(error));
  }
}
function* watchLeadStatusCreateSaga() {
  yield takeLatest(LEAD_STATUS_CREATE, leadStatusCreateSaga);
}

// LEAD_STATUS_UPDATE
function* leadStatusUpdateSaga({ payload }) {
  try {
    const response = yield call(callLeadStatusUpdateApi, payload);
    yield put(leadStatusUpdateSuccess(response));
  } catch (error) {
    yield put(leadStatusUpdateFailure(error));
  }
}
function* watchLeadStatusUpdateSaga() {
  yield takeLatest(LEAD_STATUS_UPDATE, leadStatusUpdateSaga);
}

// LEAD_STATUS_DELETE
function* leadStatusDeleteSaga({ payload }) {
  try {
    const response = yield call(callLeadStatusDeleteApi, payload);
    yield put(leadStatusDeleteSuccess(response));
  } catch (error) {
    yield put(leadStatusDeleteFailure(error));
  }
}
function* watchLeadStatusDeleteSaga() {
  yield takeLatest(LEAD_STATUS_DELETE, leadStatusDeleteSaga);
}

// LEAD_PRIORITY_LIST
function* leadPriorityListSaga({ payload }) {
  try {
    const response = yield call(callLeadPriorityListApi, payload);
    yield put(leadPriorityListSuccess(response));
  } catch (error) {
    yield put(leadPriorityListFailure(error));
  }
}
function* watchLeadPriorityListSaga() {
  yield takeLatest(LEAD_PRIORITY_LIST, leadPriorityListSaga);
}

// LEAD_PRIORITY_DATA
function* leadPriorityDataSaga({ payload }) {
  try {
    const response = yield call(callLeadPriorityDataApi, payload);
    yield put(leadPriorityDataSuccess(response));
  } catch (error) {
    yield put(leadPriorityDataFailure(error));
  }
}
function* watchLeadPriorityDataSaga() {
  yield takeLatest(LEAD_PRIORITY_DATA, leadPriorityDataSaga);
}

// LEAD_PRIORITY_CREATE
function* leadPriorityCreateSaga({ payload }) {
  try {
    const response = yield call(callLeadPriorityCreateApi, payload);
    yield put(leadPriorityCreateSuccess(response));
  } catch (error) {
    yield put(leadPriorityCreateFailure(error));
  }
}
function* watchLeadPriorityCreateSaga() {
  yield takeLatest(LEAD_PRIORITY_CREATE, leadPriorityCreateSaga);
}

// LEAD_PRIORITY_UPDATE
function* leadPriorityUpdateSaga({ payload }) {
  try {
    const response = yield call(callLeadPriorityUpdateApi, payload);
    yield put(leadPriorityUpdateSuccess(response));
  } catch (error) {
    yield put(leadPriorityUpdateFailure(error));
  }
}
function* watchLeadPriorityUpdateSaga() {
  yield takeLatest(LEAD_PRIORITY_UPDATE, leadPriorityUpdateSaga);
}

// LEAD_PRIORITY_DELETE
function* leadPriorityDeleteSaga({ payload }) {
  try {
    const response = yield call(callLeadPriorityDeleteApi, payload);
    yield put(leadPriorityDeleteSuccess(response));
  } catch (error) {
    yield put(leadPriorityDeleteFailure(error));
  }
}
function* watchLeadPriorityDeleteSaga() {
  yield takeLatest(LEAD_PRIORITY_DELETE, leadPriorityDeleteSaga);
}

// LEAD_NOTE_LIST
function* leadNoteListSaga({ payload }) {
  try {
    const response = yield call(callLeadNoteListApi, payload);
    yield put(leadNoteListSuccess(response));
  } catch (error) {
    yield put(leadNoteListFailure(error));
  }
}
function* watchLeadNoteListSaga() {
  yield takeLatest(LEAD_NOTE_LIST, leadNoteListSaga);
}

// LEAD_NOTE_SEARCH
function* leadNoteSearchSaga({ payload }) {
  try {
    const response = yield call(callLeadNoteSearchApi, payload);
    yield put(leadNoteSearchSuccess(response));
  } catch (error) {
    yield put(leadNoteSearchFailure(error));
  }
}
function* watchLeadNoteSearchSaga() {
  yield takeLatest(LEAD_NOTE_SEARCH, leadNoteSearchSaga);
}

// LEAD_NOTE_DATA
function* leadNoteDataSaga({ payload }) {
  try {
    const response = yield call(callLeadNoteDataApi, payload);
    yield put(leadNoteDataSuccess(response));
  } catch (error) {
    yield put(leadNoteDataFailure(error));
  }
}
function* watchLeadNoteDataSaga() {
  yield takeLatest(LEAD_NOTE_DATA, leadNoteDataSaga);
}

// LEAD_NOTE_CREATE
function* leadNoteCreateSaga({ payload }) {
  try {
    const response = yield call(callLeadNoteCreateApi, payload);
    yield put(leadNoteCreateSuccess(response));
  } catch (error) {
    yield put(leadNoteCreateFailure(error));
  }
}
function* watchLeadNoteCreateSaga() {
  yield takeLatest(LEAD_NOTE_CREATE, leadNoteCreateSaga);
}

// LEAD_LIST
function* leadListSaga({ payload }) {
  try {
    const response = yield call(callLeadListApi, payload);
    yield put(leadListSuccess(response));
  } catch (error) {
    yield put(leadListFailure(error));
  }
}
function* watchLeadListSaga() {
  yield takeLatest(LEAD_LIST, leadListSaga);
}

// LEAD_LIST_UNINVOICED
function* leadListUninvoicedSaga({ payload }) {
  try {
    const response = yield call(callLeadListUninvoicedApi, payload);
    yield put(leadListUninvoicedSuccess(response));
  } catch (error) {
    yield put(leadListUninvoicedFailure(error));
  }
}
function* watchLeadListUninvoicedSaga() {
  yield takeLatest(LEAD_LIST_UNINVOICED, leadListUninvoicedSaga);
}

// LEAD_OVERVIEW_FUNNEL
function* leadOverviewFunnelSaga({ payload }) {
  try {
    const response = yield call(callLeadOverviewFunnelApi, payload);
    yield put(leadOverviewFunnelSuccess(response));
  } catch (error) {
    yield put(leadOverviewFunnelFailure(error));
  }
}
function* watchLeadOverviewFunnelSaga() {
  yield takeLatest(LEAD_OVERVIEW_FUNNEL, leadOverviewFunnelSaga);
}

// LEAD_DATA
function* leadDataSaga({ payload }) {
  try {
    const response = yield call(callLeadDataApi, payload);
    yield put(leadDataSuccess(response));
  } catch (error) {
    yield put(leadDataFailure(error));
  }
}
function* watchLeadDataSaga() {
  yield takeLatest(LEAD_DATA, leadDataSaga);
}

// LEAD_CREATE
function* leadCreateSaga({ payload }) {
  try {
    const response = yield call(callLeadCreateApi, payload);
    yield put(leadCreateSuccess(response));
  } catch (error) {
    yield put(leadCreateFailure(error));
  }
}
function* watchLeadCreateSaga() {
  yield takeLatest(LEAD_CREATE, leadCreateSaga);
}

// LEAD_UPDATE
function* leadUpdateSaga({ payload }) {
  try {
    const response = yield call(callLeadUpdateApi, payload);
    yield put(leadUpdateSuccess(response));
  } catch (error) {
    yield put(leadUpdateFailure(error));
  }
}
function* watchLeadUpdateSaga() {
  yield takeLatest(LEAD_UPDATE, leadUpdateSaga);
}

// LEAD_DELETE
function* leadDeleteSaga({ payload }) {
  try {
    const response = yield call(callLeadDeleteApi, payload);
    yield put(leadDeleteSuccess(response));
  } catch (error) {
    yield put(leadDeleteFailure(error));
  }
}
function* watchLeadDeleteSaga() {
  yield takeLatest(LEAD_DELETE, leadDeleteSaga);
}

// LEAD_SEARCH
function* leadSearchSaga({ payload }) {
  try {
    const response = yield call(callLeadSearchApi, payload);
    yield put(leadSearchSuccess(response));
  } catch (error) {
    yield put(leadSearchFailure(error));
  }
}
function* watchLeadSearchSaga() {
  yield takeLatest(LEAD_SEARCH, leadSearchSaga);
}

//CALL_LEAD_TASK_SEARCH_API
function* leadTaskSearchSaga({ payload }) {
  try {
    const response = yield call(callLeadTaskSearchApi, payload);
    yield put(leadTaskSearchSuccess(response));
  } catch (error) {
    yield put(leadTaskSearchFailure(error));
  }
}
function* watchLeadTaskSearchSaga() {
  yield takeLatest(LEAD_TASK_SEARCH, leadTaskSearchSaga);
}

//CALL_LEAD_TASK_CREATE_API
function* leadTaskCreateSaga({ payload }) {
  try {
    const response = yield call(callLeadTaskCreateApi, payload);
    yield put(leadTaskCreateSuccess(response));
  } catch (error) {
    yield put(leadTaskCreateFailure(error));
  }
}
function* watchLeadTaskCreateSaga() {
  yield takeLatest(LEAD_TASK_CREATE, leadTaskCreateSaga);
}

//CALL_LEAD_TASK_TYPE_LIST_API
function* leadTaskTypeListSaga({ payload }) {
  try {
    const response = yield call(callLeadTaskTypeListApi, payload);
    yield put(leadTaskTypeListSuccess(response));
  } catch (error) {
    yield put(leadTaskTypeListFailure(error));
  }
}
function* watchLeadTaskTypeListSaga() {
  yield takeLatest(LEAD_TASK_TYPE_LIST, leadTaskTypeListSaga);
}

//CALL_LEAD_TASK_TYPE_DATA_API
function* leadTaskTypeDataSaga({ payload }) {
  try {
    const response = yield call(callLeadTaskTypeDataApi, payload);
    yield put(leadTaskTypeDataSuccess(response));
  } catch (error) {
    yield put(leadTaskTypeDataFailure(error));
  }
}
function* watchLeadTaskTypeDataSaga() {
  yield takeLatest(LEAD_TASK_TYPE_DATA, leadTaskTypeDataSaga);
}

//CALL_LEAD_TASK_TYPE_CREATE_API
function* leadTaskTypeCreateSaga({ payload }) {
  try {
    const response = yield call(callLeadTaskTypeCreateApi, payload);
    yield put(leadTaskTypeCreateSuccess(response));
  } catch (error) {
    yield put(leadTaskTypeCreateFailure(error));
  }
}
function* watchLeadTaskTypeCreateSaga() {
  yield takeLatest(LEAD_TASK_TYPE_CREATE, leadTaskTypeCreateSaga);
}

//CALL_LEAD_TASK_TYPE_UPDATE_API
function* leadTaskTypeUpdateSaga({ payload }) {
  try {
    const response = yield call(callLeadTaskTypeUpdateApi, payload);
    yield put(leadTaskTypeUpdateSuccess(response));
  } catch (error) {
    yield put(leadTaskTypeUpdateFailure(error));
  }
}
function* watchLeadTaskTypeUpdateSaga() {
  yield takeLatest(LEAD_TASK_TYPE_UPDATE, leadTaskTypeUpdateSaga);
}

//CALL_LEAD_TASK_TYPE_DELETE_API
function* leadTaskTypeDeleteSaga({ payload }) {
  try {
    const response = yield call(callLeadTaskTypeDeleteApi, payload);
    yield put(leadTaskTypeDeleteSuccess(response));
  } catch (error) {
    yield put(leadTaskTypeDeleteFailure(error));
  }
}
function* watchLeadTaskTypeDeleteSaga() {
  yield takeLatest(LEAD_TASK_TYPE_DELETE, leadTaskTypeDeleteSaga);
}

//LEAD_RECENT_ACTIVITY_LIST
function* leadRecentActivityListSaga({ payload }) {
  try {
    const response = yield call(callLeadRecentActivityListApi, payload);
    yield put(leadRecentActivityListSuccess(response));
  } catch (error) {
    yield put(leadRecentActivityListFailure(error));
  }
}
function* watchLeadRecentActivityListSaga() {
  yield takeLatest(LEAD_RECENT_ACTIVITY_LIST, leadRecentActivityListSaga);
}

export default function* leadsSaga() {
  yield all([
    watchLeadTypeListSaga(),
    watchLeadTypeDataSaga(),
    watchLeadTypeCreateSaga(),
    watchLeadTypeUpdateSaga(),
    watchLeadTypeDeleteSaga(),
    watchLeadStatusListSaga(),
    watchLeadStatusDataSaga(),
    watchLeadStatusCreateSaga(),
    watchLeadStatusUpdateSaga(),
    watchLeadStatusDeleteSaga(),
    watchLeadPriorityListSaga(),
    watchLeadPriorityDataSaga(),
    watchLeadPriorityCreateSaga(),
    watchLeadPriorityUpdateSaga(),
    watchLeadPriorityDeleteSaga(),
    watchLeadNoteListSaga(),
    watchLeadNoteSearchSaga(),
    watchLeadNoteDataSaga(),
    watchLeadNoteCreateSaga(),
    watchLeadListSaga(),
    watchLeadListUninvoicedSaga(),
    watchLeadOverviewFunnelSaga(),
    watchLeadDataSaga(),
    watchLeadCreateSaga(),
    watchLeadUpdateSaga(),
    watchLeadDeleteSaga(),
    watchLeadSearchSaga(),
    watchLeadTaskSearchSaga(),
    watchLeadTaskCreateSaga(),
    watchLeadTaskTypeListSaga(),
    watchLeadTaskTypeDataSaga(),
    watchLeadTaskTypeCreateSaga(),
    watchLeadTaskTypeUpdateSaga(),
    watchLeadTaskTypeDeleteSaga(),
    watchLeadRecentActivityListSaga(),
  ]);
}
